import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { task } from 'ember-concurrency';
import Component from '@glimmer/component';
import LinkButton from 'ember-simplepractice/components/spds/action/button/link';
import styles from './conversation-participant-names.module.scss';

export default class ConversationParticipantNames extends Component {
  @service alertManager;
  @service messaging;
  @service intl;
  @service clientProfileNavigator;

  get filteredUsers() {
    return this.args.filteredUsers;
  }

  get participantNames() {
    return this.filteredUsers.map(user => user.name).join(' & ');
  }

  get shouldShowClientProfileLink() {
    return this.clientProfileNavigator.canNavigateToClientProfile(
      this.filteredUsers,
      this.messaging.currentProfile.isClinician
    );
  }

  navigateToClientProfileTask = task({ drop: true }, async () => {
    try {
      this.clientProfileNavigator.navigateToClientProfile(
        this.args.conversation,
        this.filteredUsers
      );
    } catch (error) {
      this.alertManager.broadcast('toast', {
        message: this.intl.t('emc.general_error'),
        type: 'error',
      });
    }
  });

  @action
  handleClientProfileClick() {
    document.activeElement.blur();
    this.navigateToClientProfileTask.perform();
  }

  <template>
    <div class={{styles.component}}>
      <span class="participant-names-container">
        {{#if this.shouldShowClientProfileLink}}
          <LinkButton
            {{on "click" this.handleClientProfileClick}}
            class="participant-names"
            data-test-client-profile-link
          >
            {{this.participantNames}}
          </LinkButton>
        {{else}}
          <span class="participant-names">
            {{this.participantNames}}
          </span>
        {{/if}}

        {{#if @showAwayIndicator}}
          <span class="away-indicator" data-test-away-indicator>
            {{t "emc.away_status.indicator"}}
          </span>
        {{/if}}
      </span>
    </div>
  </template>
}
